.search-icon,
.select-color-icon {
  width: 20px;
  padding: 0.5rem;
}
